// No application-level sagas required (authentication saga removed).
// configureStore expects an array (calls appSaga.map(store.runSaga)).
function* noopSaga() {}
export default [noopSaga];
